// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../css-loader/index.js??ref--6-1!./bootstrap.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../vue-style-loader/lib/addStylesClient.js")("cc4a6db4", content, true);


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap/dist/css/bootstrap.css
// module id = Jmt5
// module chunks = 1